module.exports = __webpack_public_path__ + "static/img/1.e1e5f7da.jpg";